import React, {useState, useEffect } from "react";

import "./message.css";

import ReactEmoji from "react-emoji";
const Message = ({ message: { user, text, time, otherusername }, name, room}) => {
	let isSentByCurrentUser = false;
	const trimmedName = name.trim().toLowerCase();
	if (user === trimmedName) {
		isSentByCurrentUser = true;
	}
 
	return isSentByCurrentUser ? (
		<div  className="messageContainer justifyEnd">
			
				<p className="messageText colorwhite">
					{ReactEmoji.emojify(text)}
				</p>
				
			
			<p className="time usertime">{time}</p>
		</div>
	) : user ===
	  "admin" /*we are making the message not to display in the message box if the user is an admin*/ ? (
		""
	) : (
		<div  className="messageContainer justifyStart">
		
			
				<p className="messageText colorDark">
					 {ReactEmoji.emojify(text)}
				</p>	
				
		
			<p className="time otherusertime"><i style={{color:"green"}}>{user}</i>{`${time}`}</p>
		</div>
	);
}; 
export default Message; 
